module.exports = __webpack_public_path__ + "7419d65215df33f4bc1b0ee938dbaae4.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/list/subImg/wenquan_hz.png
// module id = 1169
// module chunks = 0